<div class="sw-cms-block-moorl-column-layout-1">
    <slot name="slot-a"></slot>
</div>